import { default as mediaQueryObj } from './desktop.module.less';

export const isDesktop = () =>
	window.matchMedia(mediaQueryObj.desktopQuery).matches;
